import React from "react";
export default function tpsText() {
  return <span>TPS</span>;
}
